export default function installServiceWorker() {
    if (!__DEV__ && 'serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            navigator.serviceWorker.register('/service-worker.js')
                .then(registration => {
                console.log('ServiceWorker registration successful with scope: ', registration.scope);
            })
                .catch(err => {
                console.error('ServiceWorker registration failed: ', err);
            });
        });
    }
}
